import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/context/AuthContext";
import { ProtectedRoute } from "@/components/ProtectedRoute";
import { AppLayout } from "@/components/AppLayout";
import { VisitorTracker } from "@/components/VisitorTracker";
import "leaflet/dist/leaflet.css";
import "@/App.css";

import Landing from "@/pages/Landing";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import Onboarding from "@/pages/Onboarding";
import Dashboard from "@/pages/Dashboard";
import Scan from "@/pages/Scan";
import Assistant from "@/pages/Assistant";
import Health from "@/pages/Health";
import Drive from "@/pages/Drive";
import Care from "@/pages/Care";
import Expenses from "@/pages/Expenses";
import Parking from "@/pages/Parking";
import Safety from "@/pages/Safety";
import Insurance from "@/pages/Insurance";
import Profile from "@/pages/Profile";
import Premium from "@/pages/Premium";
import More from "@/pages/More";
import Admin from "@/pages/Admin";
import SuperAdmin from "@/pages/SuperAdmin";

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <VisitorTracker />
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route
              path="/onboarding"
              element={
                <ProtectedRoute>
                  <Onboarding />
                </ProtectedRoute>
              }
            />
            <Route
              path="/app"
              element={
                <ProtectedRoute>
                  <AppLayout />
                </ProtectedRoute>
              }
            >
              <Route index element={<Dashboard />} />
              <Route path="scan" element={<Scan />} />
              <Route path="assistant" element={<Assistant />} />
              <Route path="health" element={<Health />} />
              <Route path="drive" element={<Drive />} />
              <Route path="care" element={<Care />} />
              <Route path="expenses" element={<Expenses />} />
              <Route path="parking" element={<Parking />} />
              <Route path="safety" element={<Safety />} />
              <Route path="insurance" element={<Insurance />} />
              <Route path="profile" element={<Profile />} />
              <Route path="premium" element={<Premium />} />
              <Route path="more" element={<More />} />
            </Route>
            <Route
              path="/admin"
              element={
                <ProtectedRoute admin>
                  <Admin />
                </ProtectedRoute>
              }
            />
            <Route
              path="/admin/live"
              element={
                <ProtectedRoute admin>
                  <SuperAdmin />
                </ProtectedRoute>
              }
            />
          </Routes>
          <Toaster position="top-center" richColors />
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;
